<div class="main-container"
  [ngClass]="(userService.currentUser?.isTrial && !userService.currentUser.hasActivePlan) ||userService.currentUser?.isShowAuthNotification || (!userService.currentUser?.advertisingAccess && userService.currentUser?.marketplace != 'JP') ? 'notification-bar' : ''">
  <router-outlet></router-outlet>
  <div class="preloader-wrapper" *ngIf="userService.loader">
    <div class="overlay"></div>
    <div class="preloader">
      <img src="../../../assets/images/preloader.svg" alt="preloader">
    </div>
  </div>
</div>